import React, { useReducer } from 'react'
import BidContext from './bidContext'
import BidReducer from './bidReducer'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import { RESPONSE_STATUS, CLEAR_RESPONSE } from './bidTypes'

const BidState = (props) => {
    const initialState = {
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(BidReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    // Bid Confirm
    const bidConfirm = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'confirm', formData, '', 'reverse/bid'),
            ])
        } catch (err) {
            resp.commonErrorResponse('bid')
        }
    }

    // Clear Response
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <BidContext.Provider
            value={{
                responseStatus: state.responseStatus,
                clearResponse,
                bidConfirm,
            }}
        >
            {props.children}
        </BidContext.Provider>
    )
}

export default BidState
